module.exports = __webpack_public_path__ + "static/jay-geraghty-lg-9e3fe7f4051ed99517548acd48c76ec9.png";